export default __webpack_public_path__ + "static/media/dash-macbook.7585dd73.png";